// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component, Input, OnInit } from '@angular/core';
import { Countries, ICountry } from 'src/types/countries';
import { Validators, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';

@Component({
    selector: 'app-country-code-form-field',
    templateUrl: './country-code.component.html',
    standalone: false
})
export class CountryCodeComponent implements OnInit {
  countries = Countries;
  @Input() formGroup: UntypedFormGroup;
  @Input() zipCodeControl: UntypedFormControl;
  @Input() countryControl: UntypedFormControl;
  @Input() styles: {} = {};
  @Input() required = false;
  @Input() appearance: MatFormFieldAppearance = 'outline';

  ngOnInit() {
    setTimeout(() => this.setValidators());
  }

  compareCountries(c1: ICountry, c2: ICountry): boolean {
    if (c1 && c2) {
      return c1.code === c2.code;
    }
    return false;
  }

  countryChanged() {
    this.setValidators();
  }

    setValidators() {
        if (this.zipCodeControl) {
            if (this.formGroup.value.country?.code === 'US') {
                this.zipCodeControl.setValidators([Validators.pattern(/^\d{5}(-\d{4})?$/)]);
            } else {
                this.zipCodeControl.clearValidators();
            }
            this.zipCodeControl.updateValueAndValidity({emitEvent: true});
        }
    }

}
